import CoreApi from '@/api/CoreApi';
import type { Nps } from '@/models/Nps';

export async function npsAvailable(): Promise<boolean> {
  try {
    const response = await CoreApi.axiosClient.get('/nps/available');
    return response.data.available;
  } catch (error) {
    console.error(error);
    return false;
  }
}

export async function sendNps(nps: Nps): Promise<void> {
  try {
    await CoreApi.axiosClient.post('/nps', nps);
  } catch (error) {
    console.error(error);
  }
}

export async function loadNps(): Promise<Nps[]> {
  try {
    const response = await CoreApi.axiosClient.get('/nps/summary');
    return response.data;
  } catch (error) {
    console.error(error);
    throw new Error('Failed to fetch NPS records');
  }
}
